export const getIsAccessDisabled = (code) => {
  if (code === 40349 || code === 40348) {
    return true;
  } else {
    return false;
  }
};
